import { render, staticRenderFns } from "./NormalPlayer.vue?vue&type=template&id=28ff2e01&scoped=true&"
import script from "./NormalPlayer.vue?vue&type=script&lang=js&"
export * from "./NormalPlayer.vue?vue&type=script&lang=js&"
import style0 from "./NormalPlayer.vue?vue&type=style&index=0&id=28ff2e01&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ff2e01",
  null
  
)

export default component.exports